let countdownTimer = undefined
let periodicalQuery = undefined
window.App.Components.TempUserTimer = class TempUserTimer {
  constructor() {
    // A countdown timer that we can use for display in the warning modal
    countdownTimer = function (duration, display) {
      let timer = duration
      let minutes = undefined
      let seconds = undefined
      setInterval(function () {
        minutes = parseInt(timer / 60, 10)
        seconds = parseInt(timer % 60, 10)
        minutes = minutes < 10 ? "0" + minutes : minutes
        seconds = seconds < 10 ? "0" + seconds : seconds
        display.text(minutes + ":" + seconds)
        if (--timer < 0) {
          timer = duration
        }
      }, 1000)
    }

    // We use a server heartbeat so that closed browsers might also terminate
    // the session.
    periodicalQuery = function () {
      $.ajax({
        url: "/active",
        dataType: "json",
        success(data) {
          console.log(data)
          if (data.live === false) {
            // Session ended by server
            this.endSession()
          }
        },
      })
      setTimeout(periodicalQuery, 30000)
    }

    this.timeoutWarning = 480000 // Display warning in 8 mins.
    this.timeoutNow = 120000 // Warning has been shown, give user 2 mins to interact
    this.logoutUrl = "/timeout" // URL to logout page.

    setTimeout(periodicalQuery, 30000)

    //# Button click handlers ##
    // timeout and redirect on close page
    $(document).on("click", ".js-temp-user-logout", () => {
      return this.timeout()
    })

    // TODO: This is not triggered with the new lesson page layout.
    // This whole file should probably be rewitten to not use jquery.
    // click continue, or in lesson panel
    $(document).on(
      "click",
      `.js-temp-user-continue, \
.lessonsShowView .panels`,
      () => {
        return this.reset()
      }
    )

    // end session on click "next section"
    $(document).on("click", ".nextS a", () => {
      console.log("ending session")
      return this.endSession()
    })

    // add duration of video remaining to timer if playing started
    $(document).on("VideoPlayer::started", (e, target) => {
      const currentTime = target.getCurrentTime()
      const videoDuration = target.getDuration()
      if (videoDuration) {
        return this.reset(
          this.timeoutWarning + (videoDuration - currentTime) * 1000
        )
      }
    })

    // reset timer to default if video paused
    $(document).on("VideoPlayer::paused", (e, target) => {
      return this.reset()
    })
  }

  // Logout the user
  timeout() {
    console.log("timeout")
    return (window.location = this.logoutUrl)
  }

  endSession() {
    console.log("end session")
    return $.ajax({
      type: "get",
      dataType: "script",
      url: this.logoutUrl,
    })
  }

  // Show idle timeout warning dialog.
  warning() {
    console.log("warning")
    clearTimeout(this.warningTimer)
    this.timeoutTimer = setTimeout(() => {
      return this.timeout()
    }, this.timeoutNow)
    BetterModals.showModal($("#modalLogoutWarning"))
    // Initiate a realtime countdown within the modal
    return countdownTimer(this.timeoutNow / 1000, $("#countdown-timer"))
  }

  // Start warning timer.
  start(duration) {
    console.log("start")

    return (this.warningTimer = setTimeout(() => {
      return this.warning()
    }, duration || this.timeoutWarning))
  }

  // Reset timers.
  reset(duration) {
    console.log("reset")
    clearTimeout(this.warningTimer)
    clearTimeout(this.timeoutTimer)
    this.start(duration)
    return BetterModals.closeModal($("#modalLogoutWarning"))
  }
}
